<template>
  <div>
    <div class="filter-container">
      <div class="search-box">
        <b-dropdown text="الترتيب حسب">
          <b-dropdown-item href="#">السعر</b-dropdown-item>
          <b-dropdown-item href="#">التقيم</b-dropdown-item>
          <b-dropdown-item href="#">التاريخ</b-dropdown-item>
        </b-dropdown>
      </div>
      <hr>
      <div class="search-box">
        <p class="text-center h4">السعر</p>
        <VueSlider v-model="priceRange"  :min="0" :max="500" :interval="2"></VueSlider>
        <p class="text-center h4 range-price-p">{{priceRange[0] + '~' + priceRange[1]}}</p>
      </div>
      <hr>
      <div class="search-box">
        <p class="text-center h4">التقييم</p>
        <span class="stars-container">
          <i
          :class="{
            'icon-star-empty' : index < selectedRate,
            'icon-star': index > selectedRate -1,
          }"
          v-for="(star, index) in 5"
          :key="index +'any'" @click="selectRate(index)"
          ></i>
        </span>
      </div>
      <hr>
      <div class="search-box">
        <p class="text-center h4">المكان</p>
        <b-form-input v-model="searchCity" placeholder="اسم المدينه"></b-form-input>
      </div>
      <div class="checkbox-container">
        <b-form-checkbox
        v-for="city in searchCityFunction()"
        :id="city.name"
        :key="city.name"
        :name="city.name"
        :value="city.name"
        unchecked-value="not_accepted"
        >
        {{city.name}}
        </b-form-checkbox>
        <p v-if="searchCityFunction() == ''" class="text-center">No Search Resault</p>
      </div>
      <hr>
      <div class="search-box">
        <p class="text-center h4">التصنيفات</p>
        <b-form-input v-model="searchProg" placeholder="اسم البرنامج"></b-form-input>
      </div>
      <div class="checkbox-container">
        <b-form-checkbox
        v-for="prog in searchProgFunction()"
        :id="prog.name"
        :key="prog.name"
        :name="prog.name"
        :value="prog.name"
        unchecked-value="not_accepted"
        >
        {{prog.name}}
        </b-form-checkbox>
        <p v-if="searchProgFunction() == ''" class="text-center">No Search Resault</p>
      </div>
      <div class="search-box">
        <p class="text-center h4">الفنادق</p>
        <autocomplete
          source="https://api.github.com/search/repositories?q="
          results-property="items"
          results-display="full_name"
          placeholder="بحث باسم الفنادق"
          >
        </autocomplete>
      </div>
      <hr>
      <div class="search-box">
        <p class="text-center h4">التاجز</p>
        <multiselect
          placeholder="اختر النشاطات"
          :multiple="true"
          v-model="selectedTags"
          :options="tags">
        </multiselect>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Autocomplete from 'vuejs-auto-complete'
import Multiselect from 'vue-multiselect'
import VueSlider       from 'vue-slider-component'


//class
import 'vue-slider-component/theme/default.css'

  export default {
    name:'ProgramsConetnt',
    components:{
      VueSlider,
      Multiselect,
      Autocomplete
    },
    data() {
      return {

        searchCity:'',
        searchProg:'',
        priceRange:[100, 400],
        selectedRate:0,
        selectedTags:null,
        tags:["صحراء", "بحر","جبل","تاريح","طبيعة"],
        progs: [
          {
            name:'الايمارات'
          },
          {
            name:'قطر'
          },
          {
            name:'لبنان'
          }
        ],
        cyties:[
          {
            name:'العين السحنه',
          },
          {
            name:'شرم الشيخ',
          },
          {
            name:'الاقصر'
          },
        ]
      }
    },
    methods: {

      //select rate
      selectRate(value) {
        this.selectedRate = value
      },

      //search Programs
      searchProgFunction() {
        var vm = this;
        return this.progs.filter(function(prog){
          return prog.name.indexOf(vm.searchProg) !== -1
        })
      },

      //search city
      searchCityFunction() {
        var vm = this
        return this.cyties.filter(function (city) {
          return city.name.indexOf(vm.searchCity) !== -1
        })
      }
    },
    watch: {
      'searchCity' : function() {
        this.searchCityFunction()
      },
      'searchProg' : function() {
        this.searchProgFunction()
      }
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
